export default __webpack_public_path__ + "static/media/Monocle.f71708fe.jpg";